//import useGlobalStore from "@/stores/global.store";
import { useQuery } from '@tanstack/react-query';

import { Sale } from '@/types/api/sale';
import api from '@/api';

type SaleQueryKey = ['sales'];

export function useSalesQuery() {
  return useQuery<Sale[], Error, Sale[], SaleQueryKey>({
    queryKey: ['sales'],
    queryFn: () => api.sale.listByGroup(),
  });
}
